import { Capacitor } from '@capacitor/core';

// On native (Android/iOS) use the custom scheme so the OS routes the Cognito
// redirect back into the app instead of opening a browser tab.
const NATIVE_REDIRECT_URI = 'com.preminade.app://callback';

export const awsConfig = {
  region: import.meta.env.VITE_AWS_REGION || 'eu-west-2',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    domain: import.meta.env.VITE_COGNITO_DOMAIN,
    redirectUri: Capacitor.isNativePlatform()
      ? NATIVE_REDIRECT_URI
      : (import.meta.env.VITE_COGNITO_REDIRECT_URI || window.location.origin),
    scopes: ['openid', 'email', 'profile'],
  },
};

// Cognito Hosted UI URLs
export function getCognitoLoginUrl(provider?: 'Google' | 'Facebook'): string {
  const { domain, clientId, redirectUri, scopes } = awsConfig.cognito;
  const params = new URLSearchParams({
    client_id: clientId,
    response_type: 'code',
    scope: scopes.join(' '),
    redirect_uri: redirectUri,
    ...(provider ? { identity_provider: provider } : {}),
  });
  return `https://${domain}/oauth2/authorize?${params}`;
}

// Goes straight to the Hosted UI's SIGN-UP form rather than sign-in — used by
// the university flow, whose users are almost always new. The Hosted UI in use
// (Managed Login v1) ignores login_hint, so the email can't be pre-filled; the
// university screen tells people to reuse the same address.
export function getCognitoSignUpUrl(): string {
  const { domain, clientId, redirectUri, scopes } = awsConfig.cognito;
  const params = new URLSearchParams({
    client_id: clientId,
    response_type: 'code',
    scope: scopes.join(' '),
    redirect_uri: redirectUri,
  });
  return `https://${domain}/signup?${params}`;
}

export function getCognitoLogoutUrl(): string {
  const { domain, clientId, redirectUri } = awsConfig.cognito;
  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: redirectUri,
  });
  return `https://${domain}/logout?${params}`;
}

export function getCognitoTokenUrl(): string {
  return `https://${awsConfig.cognito.domain}/oauth2/token`;
}
